import React from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';

const Health: React.FC = () => {
  return (
    <Box>
      <Heading size="lg" mb={4} color="white">System Health</Heading>
      <Text color="gray.300">
        System health monitoring dashboard will be implemented here.
        This will show platform uptime, service status, and performance metrics.
      </Text>
    </Box>
  );
};

export default Health;